import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect } from "react";

import If from "~/core/ui/If";

import OutlinedButton from "~/components/Buttons/OutlinedButton";

import { faPlus, faSearch } from "@fortawesome/pro-regular-svg-icons";

import { useAddContact } from "../../hooks/useAddContact";

interface AddContactProps {
  inputValue: string;
  isSearchEnabled: boolean;
  isMultiContact: boolean;
  setIsOpenDropdown: (isOpen: boolean) => void;
}

export const AddContact = (props: AddContactProps) => {
  const { inputValue, isSearchEnabled, setIsOpenDropdown, isMultiContact } =
    props;
  const { handleOnAddContact, addingNewContact, isValidEmail } = useAddContact(
    inputValue,
    isMultiContact,
  );

  const addContact = useCallback(async () => {
    await handleOnAddContact();
    setIsOpenDropdown(false);
  }, [handleOnAddContact, setIsOpenDropdown]);

  // Trigger handleOnAddContact on enter key press
  useEffect(() => {
    if (!isValidEmail) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        addContact();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [addContact, isValidEmail]);

  return (
    <div className="flex flex-col gap-4 px-3">
      <If
        condition={isSearchEnabled}
        fallback={
          <div className="text-center text-xs text-light">
            <FontAwesomeIcon icon={faSearch} />
            <p>Search for contact...</p>
          </div>
        }
      >
        <If condition={isValidEmail}>
          <div className="flex flex-col items-start">
            <p className="font-medium text-darker">New contact detected</p>
            <p className="text-light">
              &quot;{inputValue}&quot; isn&apos;t in your CRM yet. Would you
              like to add them as a new contact?
            </p>
          </div>
          <OutlinedButton
            type="dashed"
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              addContact();
            }}
            loading={addingNewContact}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            Create and add
          </OutlinedButton>
        </If>
      </If>
    </div>
  );
};
